export default {
  zh_CN: {
    0: "简体",
    1: "简体中文"
  },
  en_US: {
    0: "en",
    1: "English"
  }
};
